import { render } from "./AdminOverview.vue?vue&type=template&id=0994cd42&scoped=true&ts=true"
import script from "./AdminOverview.vue?vue&type=script&lang=ts"
export * from "./AdminOverview.vue?vue&type=script&lang=ts"

import "./AdminOverview.vue?vue&type=style&index=0&id=0994cd42&lang=scss&scoped=true"

import exportComponent from "/opt/pptcopilot/app/ppt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0994cd42"]])

export default __exports__